module.exports = __webpack_public_path__ + "static/media/Process-Sketch.b2649c4e.gif";